import React from "react";
import Scheduled from "../statuspages/Scheduled";
import Blueprint from "../statuspages/Blueprint";
import BodyRepair from "../statuspages/BodyRepair";
import PaintPrep from "../statuspages/PaintPrep";
import Paint from "../statuspages/Paint";
import Reassembly from "../statuspages/Reassembly";
import Detail from "../statuspages/Detail";
import QC from "../statuspages/QC";
import Ready from "../statuspages/Ready";
import Delivered from "../statuspages/Delivered";
import Total from "../statuspages/Total";
import Unknown from "../statuspages/Unknown";

const StatusResult = (props) => {
    return (
        <div className="col-md-12">
            {
                {
                    'Scheduled': <Scheduled VehEntry={props.details} />,
                    'Estimate Pending': <Blueprint VehEntry={props.details} />,
                    'Dropped/Assigned': <Blueprint VehEntry={props.details} />,
                    'Dropped/Not Assigned': <Blueprint VehEntry={props.details} />,
                    'Repair in Progress': <BodyRepair VehEntry={props.details} />,
                    'Paint Queue': <PaintPrep VehEntry={props.details} />,
                    'Paint in Progress': <Paint VehEntry={props.details} />,
                    'In Re-assembly': <Reassembly VehEntry={props.details} />,
                    'In Re-Assembly': <Reassembly VehEntry={props.details} />,
                    'Ready for Detail': <Detail VehEntry={props.details} />,
                    'In Detail': <Detail VehEntry={props.details} />,
                    'Ready for Test Drive': <QC VehEntry={props.details} />,
                    'Ready for Delivery': <Ready VehEntry={props.details} />,
                    'Delivered': <Delivered VehEntry={props.details} />,
                    'Total Loss': <Total VehEntry={props.details} />,
                    'Unknown': <Unknown VehEntry={props.details} />
                }[props.details.Status]
            }
        </div>
    )
}

export default StatusResult